import React, {useEffect, useState} from "react";
import {Card, CardBody, Col, Label, Row} from "reactstrap";
import {formatDDMMYYY, getLastFiveYear, getMonths, setLoadingIdle, toCopFormat} from "../../../Utils/Utils";
import {useDispatch, useSelector} from "react-redux";
import {
  BY,
  SHIPMENTS_BY_DAY,
  SHIPMENTS_BY_MONTH,
  SHIPMENTS_BY_WEEK,
  SHIPMENTS_BY_YEAR
} from "../../../Store/Shipments/Types";
import {ShipmentActions} from "../../../Store/Shipments/Slice";
import {RootState} from "../../../Store/Reducers";
import moment from "moment";
import {HorizontalBar, Radar} from "react-chartjs-2";
import PaymentTypesCode from "../../Contants/PaymentTypesCode";
import {PaymentType, Shipment} from "../../../Models";
import LoadingComponent from "../../Shared/LoadingComponent";
import {LOADING_SHIPMENT_WITH_BILLS} from "../../../Store/Loading/Types";
import DownloadReport from "./DownloadReport";

interface DateRage {
  start: Date,
  end: Date
}

interface IProps extends DateRage {
  by: BY,
  currentTab: BY;
}

const CardReportComponent = ({start, end, by, currentTab}: IProps) => {

  const dispatch = useDispatch ();
  const shipments = useSelector((state: RootState) => state.ShipmentReducer[by]);
  const {companies} = useSelector((state: RootState) => state.CompanyReducer);
  const shipmentsReport: Array<any> = shipments.map((shipment: any) => ({
    customer_to_bill_name: shipment.customer_to_bill.name,
    total_units: shipment.units.reduce((accu: number, unit: any) => accu + unit.quantity, 0),
    customer_payment_type: (shipment.customer_payment_type as PaymentType).name,
    freight_value: shipment.freight_value,
    variable_freight: shipment.variable_freight,
    other_value: shipment.other_value,
    discount: shipment.discount,
    total_value: shipment.total_value,
    group: shipment.group,
    subgroup: shipment.subgroup,
    pickup_branch: shipment.pickup_branch,
    pickup_vehicle: shipment.pickup_vehicle,
    customer: shipment.customer,
    pickup_date: shipment.pickup_date,
    status: shipment.status,
    consecutive: shipment.consecutive,
    pickup_city: shipment.pickup_city,
    delivery_city: shipment.delivery_city,
    receiver_name: shipment.receiver_name,
    weight: shipment.weight,
    delivery_date: shipment.delivery_date,
    tracking_code: shipment.tracking_code,
  }));
  const {loadingShipmentWithBills} = useSelector((state: RootState) => state.LoadingReducer);

  const [weekSelected, setWeekSelected] = useState<DateRage>({start, end});
  const [weekIndex, setWeekIndex] = useState<number>(-1);


  const [daySelected, setDaySelected] = useState<number>(end.getDate());
  const [monthSelected, setMonthSelected] = useState<Date>(end);
  const [yearSelected, setYearSelected] = useState<Date>(end);

  const [weeks, setWeeks] = useState<DateRage[]>([])

  const getDays = () => {
    const firstDay = new Date(yearSelected.getFullYear(), monthSelected.getMonth(), 1, 0, 0, 0)
    const lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 1, 0, 0, 0, 0);
    const days = [];
    for (let index = 1; index <= lastDay.getDate(); index++) {
      days.push(index);
    }
    return days;
  }

  useEffect(() => {
    const firstDay = new Date(yearSelected.getFullYear(), monthSelected.getMonth(), 1, 0, 0, 0)
    const lastDay = new Date(firstDay.getFullYear(), firstDay.getMonth() + 1, 0, 0, 0, 0);

    let start = moment(firstDay, "DD-MM-YYYY").weeks();
    let end = moment(lastDay, "DD-MM-YYYY").weeks();

    const weekDates = []

    if (end === 1) end = 53;

    for (let index = start; index <= end; index++) {
      let from = moment(firstDay).week(index).set("hour", 0).set("minute", 0).set("second", 0)//.toDate();
      let to: any = moment(firstDay).week(index).add(6, "days").set("hour", 23).set("minute", 59).set("second", 59)//.toDate()
      if (to.toDate().getFullYear() > from.toDate().getFullYear()) {
        to = new Date(from.toDate().getFullYear(), from.toDate().getMonth() + 1, 0, 23, 59, 59)
      } else {
        to = to.toDate();
      }

      weekDates.push({
        start: from.toDate(),
        end: to,
      })
    }

    setWeeks(weekDates);
  }, [monthSelected, yearSelected]);

  useEffect(() => {
    if (by === SHIPMENTS_BY_WEEK && weeks.length > 0 && weekIndex === -1) {
      weeks.forEach((w, index) => {
        if (end.getTime() <= w.end.getTime() && end.getTime() >= w.start.getTime()) {
          setWeekIndex(index)
        }
      });
    }
  }, [weeks, by, end, weekIndex]);

  useEffect(() => {
    if (by === currentTab) {
      if (currentTab === SHIPMENTS_BY_YEAR) { //Ok
        dispatch(ShipmentActions.getShipmentsWithBill({
          start: new Date(yearSelected.getFullYear(), 0, 1, 0, 0, 0),
          end: new Date(yearSelected.getFullYear(), 11, 31, 23, 59, 59),
          by: SHIPMENTS_BY_YEAR,
          logged_customer_key: companies[0]?.customer?._KEY
        }));
      }
      if (currentTab === SHIPMENTS_BY_MONTH) { //Ok
        dispatch(ShipmentActions.getShipmentsWithBill({
          start: new Date(yearSelected.getFullYear(), monthSelected.getMonth(), 1, 0, 0, 0),
          end: new Date(yearSelected.getFullYear(), monthSelected.getMonth() + 1, 0, 23, 59, 59),
          by: SHIPMENTS_BY_MONTH,
          logged_customer_key: companies[0]?.customer?._KEY

        }));
      }
      if (currentTab === SHIPMENTS_BY_WEEK) { //Ok
        dispatch(ShipmentActions.getShipmentsWithBill({
          start: weekSelected.start,
          end: weekSelected.end,
          by: SHIPMENTS_BY_WEEK,
          logged_customer_key: companies[0]?.customer?._KEY
        }));
      }
      if (currentTab === SHIPMENTS_BY_DAY) {
        dispatch(ShipmentActions.getShipmentsWithBill({
          start: new Date(yearSelected.getFullYear(), monthSelected.getMonth(), daySelected, 0, 0, 0),
          end: new Date(yearSelected.getFullYear(), monthSelected.getMonth(), daySelected, 23, 59, 59),
          by: SHIPMENTS_BY_DAY,
          logged_customer_key: companies[0]?.customer?._KEY
        }));
      }
    }
  }, [by, dispatch, currentTab, daySelected, monthSelected, weekSelected, yearSelected,companies]);

  useEffect(() => {
    if (by === currentTab && loadingShipmentWithBills.status.isResolved()) {
      dispatch(setLoadingIdle(LOADING_SHIPMENT_WITH_BILLS));
    }
  }, [by, dispatch, currentTab, loadingShipmentWithBills]);

  const withPaymentType = (shipment: Shipment, paymentType: number): boolean => (
    (shipment.customer_payment_type as PaymentType).code === paymentType
  )

  const cash = shipments.filter(shipment => withPaymentType(shipment, PaymentTypesCode.CONTADO_CODE));

  const uponDelivery = shipments.filter(shipment => withPaymentType(shipment, PaymentTypesCode.CONTRA_ENTREGA_CODE));

  const credit = shipments.filter(shipment => withPaymentType(shipment, PaymentTypesCode.CREDITO_CODE));

  const generateValuesByProperty = (property: string) => {
    const data = [
      cash.reduce((acc: number, item: any) => acc + item[property], 0.0),
      uponDelivery.reduce((acc: number, item: any) => acc + item[property], 0.0),
      credit.reduce((acc: number, item: any) => acc + item[property], 0.0)
    ];
    data.push(data[0] + data[1] + data[2]);
    return data;
  }

  const data = {
    labels: ['Contado', "Contra-Entrega", "Crédito", "Sumatoria"],
    datasets: [
      {
        label: 'Flete fijo',
        backgroundColor: 'rgb(99,138,255,0.4)',
        borderColor: 'rgb(99,138,255,0.2)',
        borderWidth: 1,
        data: generateValuesByProperty('freight_value')
      },
      {
        label: 'Flete variable',
        backgroundColor: 'rgb(122,255,99,0.2)',
        borderColor: 'rgba(122,255,99)',
        borderWidth: 1,
        data: generateValuesByProperty('variable_freight')
      },
      {
        label: 'Otros valores',
        backgroundColor: 'rgb(240,240,100,0.6)',
        borderColor: 'rgb(240,240,100,0.4)',
        borderWidth: 1,
        data: generateValuesByProperty('other_value')
      },
      {
        label: 'Descuento',
        backgroundColor: 'rgb(113,43,253,0.4)',
        borderColor: 'rgb(113,43,253,0.2)',
        borderWidth: 1,
        data: generateValuesByProperty('discount')
      },
      {
        label: 'Total',
        backgroundColor: 'rgba(255,99,132,0.2)',
        borderColor: 'rgba(255,99,132,1)',
        borderWidth: 1,
        data: generateValuesByProperty('total_value')
      }
    ]
  };

  const data2 = {
    labels: ['Contado', "Contra-Entrega", "Crédito"],
    datasets: [
      {
        label: '# Guias',
        backgroundColor: 'rgba(255,99,132,0.2)',
        borderColor: 'rgba(255,99,132,1)',
        borderWidth: 1,
        data: [
          cash.length,
          uponDelivery.length,
          credit.length
        ]
      },
      {
        label: 'Total Unidades',
        backgroundColor: 'rgb(99,138,255,0.4)',
        borderColor: 'rgb(99,138,255,0.2)',
        borderWidth: 1,
        data: [
          cash.reduce((acc: number, item: any) => {
            return acc + item.units.reduce((accu: number, unit: any) => accu + unit.quantity, 0);
          }, 0),
          uponDelivery.reduce((acc: number, item: any) => {
            return acc + item.units.reduce((accu: number, unit: any) => accu + unit.quantity, 0);
          }, 0),
          credit.reduce((acc: number, item: any) => {
            return acc + item.units.reduce((accu: number, unit: any) => accu + unit.quantity, 0);
          }, 0)
        ]
      }
    ]
  }

  const options = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          },
        },
      ],
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            callback: function(label: string) {
              return toCopFormat(parseFloat(label));
            }
          }
        }
      ]
    },
    tooltips: {
      callbacks: {
        label: function(tooltipItem: any) {
          return toCopFormat(parseFloat(tooltipItem.xLabel));
        }
      }
    }
  }

  // const options2 = {
  //   tooltips: {
  //     enabled: false
  //   },
  //   plugins: {
  //     datalabels: {
  //       formatter: (value: any, ctx: any) => {
  //         let dataArr = ctx.chart.data.datasets[0].data;
  //         const sum = dataArr.reduce((acc: number, item: number) => acc + item, 0.0);
  //         return (value * 100 / sum).toFixed(2) + "%";
  //       },
  //       color: '#000',
  //     }
  //   }
  // }

  return (
    <Card className="tab-card">
      <CardBody>
        <Row>
          <Col sm={12} md={6} lg={4}>
            {
              by === SHIPMENTS_BY_DAY &&
              <>
                <Label>Día:</Label>&nbsp;
                <select className="form-control"
                        defaultValue={end.getDate()}
                        onChange={(e) => {
                          setDaySelected(parseInt(e.currentTarget.value))
                        }}
                >
                  {
                    getDays().map((day) => (
                      <option value={day} key={`day_${day}`}>{day}</option>
                    ))
                  }
                </select>
              </>
            }
            {
              by === SHIPMENTS_BY_WEEK &&
              <>
                <Label>Semana:</Label>&nbsp;
                <select className="form-control"
                        onChange={(e) => {
                          const index = parseInt(e.currentTarget.value);
                          setWeekIndex(index);
                          setWeekSelected(weeks[index]);
                        }}
                        value={weekIndex}
                >
                  {
                    weeks.map((week, index) => (
                      <option value={index} key={`week_${index}`}>
                        Desde {formatDDMMYYY(week.start)} -
                        Hasta {formatDDMMYYY(week.end)}
                      </option>
                    ))
                  }
                </select>
              </>
            }
          </Col>
          <Col sm={12} md={6} lg={4}>
            {
              (by !== SHIPMENTS_BY_YEAR) &&
              <>
                <Label>Mes:</Label>&nbsp;
                <select className="form-control"
                        defaultValue={end.getMonth()}
                        onChange={(e) => {
                          const m = parseInt(e.currentTarget.value)
                          const newMonth = new Date(yearSelected.getFullYear(), m);
                          setMonthSelected(newMonth)
                        }}
                >
                  {
                    getMonths().map((month, index) => (
                      <option value={index} key={`months_${index}`}>{month}</option>
                    ))
                  }
                </select>
              </>
            }
          </Col>
          <Col className="form-group" sm={12} md={6} lg={4}>
            <Label>Año:</Label>&nbsp;
            <select className="form-control"
                    defaultValue={end.getFullYear()}
                    onChange={(e) => {
                      const y = parseInt(e.currentTarget.value)
                      const newYear = new Date();
                      newYear.setFullYear(y)
                      setYearSelected(newYear)
                    }}
            >
              {
                getLastFiveYear().map(year => (
                  <option value={year.getFullYear()} key={year.getFullYear()}>{year.getFullYear()}</option>
                ))
              }
            </select>
          </Col>
        </Row>
        <br/>
        {
          loadingShipmentWithBills.status.isLoading() ?
            <LoadingComponent loading={loadingShipmentWithBills.status}/> :
            <Row>
              {
                shipmentsReport.length > 0 &&
                <>
                  <Col xs="12">
                    <DownloadReport dataSet={shipmentsReport} />
                  </Col>
                  <Col>
                    <HorizontalBar data={data} options={options} />
                  </Col>
                  <Col>
                    <Radar data={data2}/>
                  </Col>
                </>
              }
              {
                shipmentsReport.length === 0 &&
                <div className="text-center w-100">
                  <h6>No se encontraron guia con las condiciones dadas</h6>
                </div>
              }
            </Row>
        }
        <br/>
        <br/>
      </CardBody>
    </Card>
  )
}

export default CardReportComponent;
